module.exports = __webpack_public_path__ + "img/jcb_82032.b392c52e.svg";